const categoryColors = {
  "Verse For Today": "rgb(255,149,0)",
  "Word Of Encouragement": "rgb(90,200,250)",
  "Passage Summary": "rgb(255,45,85)",
  "Bible Study": "rgb(255,204,0)",
};

export { categoryColors };
